import React, { CSSProperties } from "react";
import { useI18n } from "../lib/i18n/i18n_provider";
import { Picker } from "./picker";
import { useAnalytics } from "../lib/analytics/analytics";

export interface CapacityPickerProps {
  capacities: number[];
  value?: number;
  disabled?: boolean;
  optionLabel?: string;
  onChange: (value: number) => void;
  override?: {
    root?: { style?: CSSProperties };
    view?: { style?: CSSProperties };
    arrow?: { style?: CSSProperties };
  };
}

export function CapacityPicker(props: CapacityPickerProps) {
  const { disabled, value, onChange, capacities, override, optionLabel } =
    props;
  const { fbt } = useI18n();

  const options = capacities.map((n) => ({
    label:
      optionLabel !== undefined
        ? fbt(optionLabel) + " " + n
        : fbt("Fits: " + fbt.param("capacity", n) + " people max"),
    value: n,
  }));

  const displayTitle = function (value: number) {
    return optionLabel !== undefined
      ? value.toString()
      : fbt(fbt.param("max", value) + " max");
  };

  const analytics = useAnalytics();

  return (
    <Picker
      icon="capacity"
      value={value}
      placeholder={fbt("Capacity")}
      title={value ? displayTitle(value) : ""}
      options={options}
      onChange={(capacity) => {
        onChange(capacity);
        analytics.event(
          "Capacity Select Click",
          {
            Capacity: capacity,
            Source: "WL",
          },
          { onlyProviders: ["mixpanel", "customerio"] }
        );
      }}
      disabled={disabled}
      override={override}
    />
  );
}
